export default __webpack_public_path__ + "static/media/Karen_A._Szklany_AHV_In_Moms_We_Trust.e242d5c0.jpg";